import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { constantsData, identifiersData, namesData, statusTypesData, urlsData } from "@/data";
import { useApisClient } from "@/hooks";
import { openAlert, setRefetchDriveManagementList } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useDeleteDriveManagementUserPermission = () => {
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const { logout } = useAuth0();

    const { t } = useTranslation();

    const { delete: deleteApiClient } = useApisClient();

    const {
        files: { url: driveManagementFilesApiUrl },
        users: { permissions: driveManagementUsersPermissionsApiUrl },
    } = urlsData.apis.driveManagement;

    const { deleteDriveManagementUserPermissionPending: deleteDriveManagementUserPermissionPendingToastName } =
        namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const deleteDriveManagementUserPermission = (fileId, permissionId) => {
        setLoading(true);

        deleteApiClient(
            `${driveManagementFilesApiUrl}/${fileId}/${driveManagementUsersPermissionsApiUrl}`,
            permissionId,
        )
            .then(() => {
                dispatch(
                    openAlert(
                        t("messages.deleteMsgs.success", { entity: t("labels.permission") }),
                        statusTypesData.success,
                    ),
                );
            })
            ["catch"]((err) => {
                displayErrorHandler(
                    err.response.data.message === constantsData.networkError
                        ? t("messages.networkFailure")
                        : err.response.data.message,
                    dispatch,
                    openAlert,
                    err.response.status,
                    logout,
                );
            })
            ["finally"](() => {
                toast.dismiss(`${deleteDriveManagementUserPermissionPendingToastName}_${toastId}`);

                setLoading(false);

                dispatch(setRefetchDriveManagementList(true));
            });
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(() => t("messages.deleteMsgs.pending", { entity: t("labels.permission") }), {
                    toastId: `${deleteDriveManagementUserPermissionPendingToastName}_${toastId}`,
                });
            }
        },
        [loading], //eslint-disable-line
    );

    return {
        deleteDriveManagementUserPermission,
        loading,
    };
};

export default useDeleteDriveManagementUserPermission;
